import Vue from 'vue';
import Router from 'vue-router';
import basic from '../components/basic';
import expectation from '../components/expectation';

Vue.use(Router);

export default new Router({
	routes: [{
		path: '/',
		name: 'basic',
		component: basic
	},
	{
		path: '/expectation',
		name: 'expectation',
		component: expectation
	}]
});



// WEBPACK FOOTER //
// ./src/module/basic/router/index.js